<label for="chip-{{name}}">{{name}}</label>
<div class="input-group">
  <input class="form-control" type="text" id="chip-{{name}}" [(ngModel)]="value">
  <div class="input-group-append">
    <button class="btn btn-primary" type="button" (click)="add()">Add</button>
  </div>
</div>
<app-chip [chips]="values"></app-chip>
